export default __webpack_public_path__ + "static/media/IMG_3548.689fe6f0.jpg";